import { SettingsStateAction, Currency } from "../common/types";

export const SET_SELECTED_CURRENCY = "SET_SELECTED_CURRENCY";

export const setSelectedCurrency = (selectedCurrency: Currency): SettingsStateAction => ({
  type: SET_SELECTED_CURRENCY,
  selectedCurrency,
});
